import {AbstractSerializer} from '../../Abstract/Serializer';

export class BCMSerializer extends AbstractSerializer {}
